import { createAuthLink } from 'aws-appsync-auth-link';
import { ApolloLink } from '@apollo/client/core';
import { AwsConfiguration } from '../../ConfigContext/types';

export const authLink = (config: AwsConfiguration, tokenFn: () => string) => {
  return createAuthLink({
    url: config.graphQLEndpoint,
    region: config.region,
    auth: {
      type: config.authType,
      jwtToken: tokenFn,
    },
  }) as unknown as ApolloLink;
};
